import * as React from "react";

import { cn } from "@/lib/utils";

// shadcn-new-york Badge — pure DOM (no radix primitive).
// Phase 2 surfaces: state pills (Draft/Active/Closed), domain chips, filter chips.

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: "default" | "secondary" | "outline" | "destructive";
}

const VARIANT: Record<NonNullable<BadgeProps["variant"]>, string> = {
  default:
    "bg-[var(--talenta-primary)] text-[var(--talenta-primary-foreground)] border border-transparent",
  secondary:
    "bg-[var(--talenta-surface)] text-[var(--talenta-text)] border border-[var(--talenta-border)]",
  outline:
    "bg-transparent text-[var(--talenta-text)] border border-[var(--talenta-border)]",
  destructive:
    "bg-[#fef2f2] text-[#dc2626] border border-[#fecaca]",
};

export function Badge({ className, variant = "default", ...props }: BadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2 py-0.5 text-xs font-semibold",
        VARIANT[variant],
        className,
      )}
      {...props}
    />
  );
}
